export default __webpack_public_path__ + "static/1879-8a4460c89baac24f340743d541ee63d6.gif";